<template>
    <div>

        <ul class="nav nav-pills">

            <li
                class="nav-item mb-2"
                @click.prevent="selectTab"
            >
                <a
                    href="#"
                    class="nav-link py-2 px-3 mr-2"
                    :class="{ active: !tabId }"
                >
                    All
                </a>
            </li>
            <draggable
                v-model="sortedTabs"
                style="display:contents"
            >
                <li
                    v-for="tab in tabs"
                    :key="tab.id"
                    class="nav-item mb-2 costable-table-tab-draggable d-flex align-items-center"
                    :class="{ active: isTabSelected(tab.id) }"
                >
                    <div class="mr-2">
                        <b-dropdown
                            v-if="$store.getters['costable/isEditable']"
                            split
                            right
                            :text="tab.name"
                            variant="link"
                            class="nav-link"
                            menu-class="no-hover"
                            :class="{ active: isTabSelected(tab.id) }"
                            @click="selectTab(this, tab.id)"
                        >
                            <b-dropdown-header>Tab Actions</b-dropdown-header>
                            <b-dropdown-item @click="editTab(this, tab)">
                                <i class="fa fa-fw fa-pencil" />
                                <span class="ml-2">Edit</span>
                            </b-dropdown-item>
                            <b-dropdown-item @click="duplicateTab(this, tab)">
                                <i class="fa fa-fw fa-copy" />
                                <span class="ml-2">Duplicate</span>
                            </b-dropdown-item>
                            <b-dropdown-item @click="deleteTab(this, tab)">
                                <i class="fa fa-fw fa-trash" />
                                <span class="ml-2">Delete</span>
                            </b-dropdown-item>
                        </b-dropdown>
                        <b-button
                            v-else
                            variant="link"
                            class="py-2 px-3 mr-2 nav-link"
                            :class="{ active: isTabSelected(tab.id) }"
                            @click="selectTab(this, tab.id)"
                        >
                            {{ tab.name }}
                        </b-button>
                    </div>
                </li>
            </draggable>

            <li
                v-if="$store.getters['costable/isEditable']"
                class="nav-item mb-2"
                @click.prevent="openAddTabModal"
            >
                <a
                    href="#"
                    class="nav-link py-2 px-3"
                >
                    <i class="fa fa-plus" />
                    <span class="ml-1">Add Tab</span>
                </a>
            </li>

        </ul>

        <CostableTableTabsAddTabModal />
        <CostableTableTabsDuplicateTabModal />
        <CostableTableTabsDeleteTabModal />

    </div>
</template>

<script>
import draggable from 'vuedraggable';
import CostableTableTabsAddTabModal from './CostableTableTabsAddTabModal';
import CostableTableTabsDuplicateTabModal from './CostableTableTabsDuplicateTabModal';
import CostableTableTabsDeleteTabModal from './CostableTableTabsDeleteTabModal';

export default {

    components: {
        CostableTableTabsAddTabModal,
        CostableTableTabsDuplicateTabModal,
        CostableTableTabsDeleteTabModal,
        draggable,
    },

    computed: {
        tabs() {
            return this.$store.getters['costable/tabs'];
        },
        tabId() {
            return this.$store.getters['costable/tabId'];
        },
        sortedTabs: {
            get() {
                return this.tabs;
            },
            set(tabs) {
                this.$store.dispatch('costable/updateTabsOrder', tabs);
            },
        },
    },

    methods: {
        isTabSelected(id) {
            return this.tabId && this.tabId === id;
        },
        async selectTab(e, id = null) {
            await this.$store.dispatch('costable/changeTab', id);
        },
        openAddTabModal() {
            this.$eventBus.$emit(this.$events.openAddTabModal);
        },
        editTab(e, tab) {
            this.$eventBus.$emit(this.$events.openEditTabModal, tab);
        },
        duplicateTab(e, tab) {
            this.$eventBus.$emit(this.$events.openDuplicateTabModal, tab);
        },
        deleteTab(e, tab) {
            this.$eventBus.$emit(this.$events.openDeleteTabModal, tab);
        },
    },

};
</script>

<style scoped>
.costable-table-tab-draggable {
    cursor: ns-resize;
}
.nav-link {
    padding: 0;
    color: #a7b1c2;
}
.nav-link.active {
    background-color: #1ab394;
}
.nav-link /deep/ button {
    font-weight: 600;
}
.nav-link /deep/ button:hover,
.nav-link /deep/ button:focus {
    color: #a7b1c2;
}
.nav-link.active /deep/ button:hover,
.nav-link.active /deep/ button:focus {
    color: #fff;
}
/deep/ .dropdown-toggle-split {
    padding-left: 0;
}
</style>
